import { SxProps, Theme } from "@mui/material";
import { indigo } from "@mui/material/colors";

export const selectedRowColor = (t: Theme) =>
  t.palette.mode === "dark" ? t.palette.primary.dark : t.palette.primary.light;

export const gridStyle: SxProps<Theme> = {
  "&.MuiDataGrid-root .MuiDataGrid-cell:focus": {
    outline: "none",
  },
  // "& .related-row": {
  //   backgroundColor: (t) =>
  //     t.palette.mode === "dark"
  //       ? t.palette.secondary.dark
  //       : t.palette.info.dark,
  // },
  "& .row-selected": {
    bgcolor: selectedRowColor,
    "&:hover": {
      bgcolor: (t) => t.palette.action.hover,
    },
  },
  "& .MuiDataGrid-row": {
    justifyContent: "center",
    "&.Mui-selected": {
      bgcolor: selectedRowColor,
    },
    "&:hover": {
      bgcolor: (t) =>
        t.palette.mode === "dark"
          ? t.palette.action.hover
          : t.palette.grey[300],
    },
  },
  "& .MuiDataGrid-columnHeader": {
    "& .MuiDataGrid-columnHeaderTitleContainer": {
      justifyContent: "center",
    },
  },
  "& .MuiDataGrid-row:not(.MuiDataGrid-row--dynamicHeight)>.MuiDataGrid-cell": {
    overflow: "visible",
  },

  // control the color based on the algo status
  // format: algo-status--<status>
  "& .algo-status--Running": {
    backgroundColor: (t) => t.palette.background.paper,
  },
  "& .algo-status--Scheduled": {
    backgroundColor: (t) =>
      t.palette.mode === "dark" ? indigo[900] : t.palette.info.dark,
  },
  "& .algo-status--Crashed": {
    backgroundColor: (t) => t.palette.grey[600],
  },
  "& .algo-status--EmergencyStopped": {
    backgroundColor: (t) => t.palette.error.dark,
  },
  "& .algo-status--NotRunning": {
    backgroundColor: (t) => t.palette.warning.dark,
  },
  "& .algo-status--Deleting": {
    opacity: 0.5,
    textDecoration: "line-through",
  },
  borderRadius: 0,
};
